module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "rounded-lg",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v("\n    Rechnung suchen\n    "), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-2"
  }, [_c('v-autocomplete', {
    attrs: {
      "outlined": "",
      "clearable": "",
      "dense": "",
      "hide-details": "",
      "label": "Rechnungsnummer eingeben",
      "items": _vm.rechnungen
    },
    on: {
      "change": function($event) {
        _vm.selectRechnung ? (_vm.showRechnung = true) : (_vm.showRechnung = false)
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(data) {
        return [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(data.item.item.rechnungsnummer) + " | " + _vm._s(data.item.item.kasse))]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v(_vm._s(_vm.$filters.user(data.item.item.bbrID, _vm.bbrbbr)))])], 1), _vm._v(" "), _c('v-list-item-action', [_vm._v("\n          " + _vm._s(_vm._f("money")(data.item.item.summe)) + "\n        ")])]
      }
    }]),
    model: {
      value: (_vm.selectRechnung),
      callback: function($$v) {
        _vm.selectRechnung = $$v
      },
      expression: "selectRechnung"
    }
  })], 1), _vm._v(" "), _c('dialogRechnung', {
    attrs: {
      "visible": _vm.showRechnung,
      "rechnungid": _vm.selectRechnung
    },
    on: {
      "update:visible": function($event) {
        _vm.showRechnung = $event
      },
      "close": function($event) {
        _vm.showRechnung = false
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65a75046"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module_klein/rechnungSuche.vue
// module id = 787
// module chunks = 15